import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bf3604f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "industry-index" }
const _hoisted_2 = { class: "industry-index-wrap" }
const _hoisted_3 = { class: "industry-index-center" }
const _hoisted_4 = { class: "industry-index-box5" }
const _hoisted_5 = { class: "industry-index-box5-content" }
const _hoisted_6 = { class: "industry-index-box5-ct" }
const _hoisted_7 = {
  key: 0,
  class: "industry-index-box5-lt"
}
const _hoisted_8 = { class: "industry-index-box5-lt-name" }
const _hoisted_9 = { class: "industry-index-box5-lt-banner" }
const _hoisted_10 = {
  key: 0,
  class: "industry-index-box5-lt-status status3"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status3" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "industry-index-box5-lt-status status4"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status4" }, null, -1))
const _hoisted_14 = {
  key: 2,
  class: "industry-index-box5-lt-status status5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status5" }, null, -1))
const _hoisted_16 = {
  key: 3,
  class: "industry-index-box5-lt-status status6"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status6" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 查看详情")
const _hoisted_19 = { class: "industry-index-box1-lt-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议主题", -1))
const _hoisted_21 = { class: "industry-index-box1-lt-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议地点", -1))
const _hoisted_23 = { class: "industry-index-box1-lt-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议时间", -1))
const _hoisted_25 = { class: "industry-index-box1-lt-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "主办方", -1))
const _hoisted_27 = { class: "industry-index-box1-lt-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议日程", -1))
const _hoisted_29 = { style: {"height":"300px"} }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "industry-index-box5-rt" }
const _hoisted_32 = { class: "industry-index-box5-rt-hd" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 全部会议 ")
const _hoisted_34 = { class: "industry-index-box5-rt-box" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "industry-index-box5-rt-ad" }
const _hoisted_37 = {
  key: 0,
  class: "industry-index-box5-rt-status status3"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status3" }, null, -1))
const _hoisted_39 = {
  key: 1,
  class: "industry-index-box5-rt-status status4"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status4" }, null, -1))
const _hoisted_41 = {
  key: 2,
  class: "industry-index-box5-rt-status status5"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status5" }, null, -1))
const _hoisted_43 = {
  key: 3,
  class: "industry-index-box5-rt-status status6"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status6" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box5-rt-bt" }, null, -1))
const _hoisted_46 = { class: "industry-index-box5-rt-label" }
const _hoisted_47 = { class: "industry-index-box5" }
const _hoisted_48 = { class: "industry-index-box5-content" }
const _hoisted_49 = { class: "industry-index-box5-ct" }
const _hoisted_50 = {
  key: 0,
  class: "industry-index-box5-lt"
}
const _hoisted_51 = { class: "industry-index-box5-lt-name" }
const _hoisted_52 = { class: "industry-index-box5-lt-banner" }
const _hoisted_53 = {
  key: 0,
  class: "industry-index-box5-lt-status status3"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status3" }, null, -1))
const _hoisted_55 = {
  key: 1,
  class: "industry-index-box5-lt-status status4"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status4" }, null, -1))
const _hoisted_57 = {
  key: 2,
  class: "industry-index-box5-lt-status status5"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status5" }, null, -1))
const _hoisted_59 = {
  key: 3,
  class: "industry-index-box5-lt-status status6"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status6" }, null, -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 查看详情")
const _hoisted_62 = { class: "industry-index-box1-lt-item" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议主题", -1))
const _hoisted_64 = { class: "industry-index-box1-lt-item" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议地点", -1))
const _hoisted_66 = { class: "industry-index-box1-lt-item" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议时间", -1))
const _hoisted_68 = { class: "industry-index-box1-lt-item" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "主办方", -1))
const _hoisted_70 = { class: "industry-index-box1-lt-item" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议日程", -1))
const _hoisted_72 = { style: {"height":"300px"} }
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = { class: "industry-index-box5-rt" }
const _hoisted_75 = { class: "industry-index-box5-rt-hd" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 全部会议 ")
const _hoisted_77 = { class: "industry-index-box5-rt-box" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "industry-index-box5-rt-ad" }
const _hoisted_80 = {
  key: 0,
  class: "industry-index-box5-rt-status status3"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status3" }, null, -1))
const _hoisted_82 = {
  key: 1,
  class: "industry-index-box5-rt-status status4"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status4" }, null, -1))
const _hoisted_84 = {
  key: 2,
  class: "industry-index-box5-rt-status status5"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status5" }, null, -1))
const _hoisted_86 = {
  key: 3,
  class: "industry-index-box5-rt-status status6"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status6" }, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box5-rt-bt" }, null, -1))
const _hoisted_89 = { class: "industry-index-box5-rt-label" }
const _hoisted_90 = { class: "industry-index-box5" }
const _hoisted_91 = { class: "industry-index-box5-content" }
const _hoisted_92 = { class: "industry-index-box5-ct" }
const _hoisted_93 = {
  key: 0,
  class: "industry-index-box5-lt"
}
const _hoisted_94 = { class: "industry-index-box5-lt-name" }
const _hoisted_95 = { class: "industry-index-box5-lt-banner" }
const _hoisted_96 = {
  key: 0,
  class: "industry-index-box5-lt-status status3"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status3" }, null, -1))
const _hoisted_98 = {
  key: 1,
  class: "industry-index-box5-lt-status status4"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status4" }, null, -1))
const _hoisted_100 = {
  key: 2,
  class: "industry-index-box5-lt-status status5"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status5" }, null, -1))
const _hoisted_102 = {
  key: 3,
  class: "industry-index-box5-lt-status status6"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status6" }, null, -1))
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" 查看详情")
const _hoisted_105 = { class: "industry-index-box1-lt-item" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议主题", -1))
const _hoisted_107 = { class: "industry-index-box1-lt-item" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议地点", -1))
const _hoisted_109 = { class: "industry-index-box1-lt-item" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议时间", -1))
const _hoisted_111 = { class: "industry-index-box1-lt-item" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "主办方", -1))
const _hoisted_113 = { class: "industry-index-box1-lt-item" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议日程", -1))
const _hoisted_115 = { style: {"height":"300px"} }
const _hoisted_116 = ["innerHTML"]
const _hoisted_117 = { class: "industry-index-box5-rt" }
const _hoisted_118 = { class: "industry-index-box5-rt-hd" }
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" 全部会议 ")
const _hoisted_120 = { class: "industry-index-box5-rt-box" }
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { class: "industry-index-box5-rt-ad" }
const _hoisted_123 = {
  key: 0,
  class: "industry-index-box5-rt-status status3"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status3" }, null, -1))
const _hoisted_125 = {
  key: 1,
  class: "industry-index-box5-rt-status status4"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status4" }, null, -1))
const _hoisted_127 = {
  key: 2,
  class: "industry-index-box5-rt-status status5"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status5" }, null, -1))
const _hoisted_129 = {
  key: 3,
  class: "industry-index-box5-rt-status status6"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status6" }, null, -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box5-rt-bt" }, null, -1))
const _hoisted_132 = { class: "industry-index-box5-rt-label" }
const _hoisted_133 = { class: "industry-index-box5" }
const _hoisted_134 = { class: "industry-index-box5-content" }
const _hoisted_135 = { class: "industry-index-box5-ct" }
const _hoisted_136 = {
  key: 0,
  class: "industry-index-box5-lt"
}
const _hoisted_137 = { class: "industry-index-box5-lt-name" }
const _hoisted_138 = { class: "industry-index-box5-lt-banner" }
const _hoisted_139 = {
  key: 0,
  class: "industry-index-box5-lt-status status3"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status3" }, null, -1))
const _hoisted_141 = {
  key: 1,
  class: "industry-index-box5-lt-status status4"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status4" }, null, -1))
const _hoisted_143 = {
  key: 2,
  class: "industry-index-box5-lt-status status5"
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status5" }, null, -1))
const _hoisted_145 = {
  key: 3,
  class: "industry-index-box5-lt-status status6"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status6" }, null, -1))
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" 查看详情")
const _hoisted_148 = { class: "industry-index-box1-lt-item" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议主题", -1))
const _hoisted_150 = { class: "industry-index-box1-lt-item" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议地点", -1))
const _hoisted_152 = { class: "industry-index-box1-lt-item" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议时间", -1))
const _hoisted_154 = { class: "industry-index-box1-lt-item" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "主办方", -1))
const _hoisted_156 = { class: "industry-index-box1-lt-item" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议日程", -1))
const _hoisted_158 = { style: {"height":"300px"} }
const _hoisted_159 = ["innerHTML"]
const _hoisted_160 = { class: "industry-index-box5-rt" }
const _hoisted_161 = { class: "industry-index-box5-rt-hd" }
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" 全部会议 ")
const _hoisted_163 = { class: "industry-index-box5-rt-box" }
const _hoisted_164 = ["onClick"]
const _hoisted_165 = { class: "industry-index-box5-rt-ad" }
const _hoisted_166 = {
  key: 0,
  class: "industry-index-box5-rt-status status3"
}
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status3" }, null, -1))
const _hoisted_168 = {
  key: 1,
  class: "industry-index-box5-rt-status status4"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status4" }, null, -1))
const _hoisted_170 = {
  key: 2,
  class: "industry-index-box5-rt-status status5"
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status5" }, null, -1))
const _hoisted_172 = {
  key: 3,
  class: "industry-index-box5-rt-status status6"
}
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status6" }, null, -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box5-rt-bt" }, null, -1))
const _hoisted_175 = { class: "industry-index-box5-rt-label" }
const _hoisted_176 = { class: "industry-index-box5" }
const _hoisted_177 = { class: "industry-index-box5-content" }
const _hoisted_178 = { class: "industry-index-box5-ct" }
const _hoisted_179 = {
  key: 0,
  class: "industry-index-box5-lt"
}
const _hoisted_180 = { class: "industry-index-box5-lt-name" }
const _hoisted_181 = { class: "industry-index-box5-lt-banner" }
const _hoisted_182 = {
  key: 0,
  class: "industry-index-box5-lt-status status3"
}
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status3" }, null, -1))
const _hoisted_184 = {
  key: 1,
  class: "industry-index-box5-lt-status status4"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status4" }, null, -1))
const _hoisted_186 = {
  key: 2,
  class: "industry-index-box5-lt-status status5"
}
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status5" }, null, -1))
const _hoisted_188 = {
  key: 3,
  class: "industry-index-box5-lt-status status6"
}
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status6" }, null, -1))
const _hoisted_190 = /*#__PURE__*/_createTextVNode(" 查看详情")
const _hoisted_191 = { class: "industry-index-box1-lt-item" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议主题", -1))
const _hoisted_193 = { class: "industry-index-box1-lt-item" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议地点", -1))
const _hoisted_195 = { class: "industry-index-box1-lt-item" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议时间", -1))
const _hoisted_197 = { class: "industry-index-box1-lt-item" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "主办方", -1))
const _hoisted_199 = { class: "industry-index-box1-lt-item" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议日程", -1))
const _hoisted_201 = { style: {"height":"300px"} }
const _hoisted_202 = ["innerHTML"]
const _hoisted_203 = { class: "industry-index-box5-rt" }
const _hoisted_204 = { class: "industry-index-box5-rt-hd" }
const _hoisted_205 = /*#__PURE__*/_createTextVNode(" 全部会议 ")
const _hoisted_206 = { class: "industry-index-box5-rt-box" }
const _hoisted_207 = ["onClick"]
const _hoisted_208 = { class: "industry-index-box5-rt-ad" }
const _hoisted_209 = {
  key: 0,
  class: "industry-index-box5-rt-status status3"
}
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status3" }, null, -1))
const _hoisted_211 = {
  key: 1,
  class: "industry-index-box5-rt-status status4"
}
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status4" }, null, -1))
const _hoisted_213 = {
  key: 2,
  class: "industry-index-box5-rt-status status5"
}
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status5" }, null, -1))
const _hoisted_215 = {
  key: 3,
  class: "industry-index-box5-rt-status status6"
}
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status6" }, null, -1))
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box5-rt-bt" }, null, -1))
const _hoisted_218 = { class: "industry-index-box5-rt-label" }
const _hoisted_219 = { class: "industry-index-box5" }
const _hoisted_220 = { class: "industry-index-box5-content" }
const _hoisted_221 = { class: "industry-index-box5-ct" }
const _hoisted_222 = {
  key: 0,
  class: "industry-index-box5-lt"
}
const _hoisted_223 = { class: "industry-index-box5-lt-name" }
const _hoisted_224 = { class: "industry-index-box5-lt-banner" }
const _hoisted_225 = {
  key: 0,
  class: "industry-index-box5-lt-status status3"
}
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status3" }, null, -1))
const _hoisted_227 = {
  key: 1,
  class: "industry-index-box5-lt-status status4"
}
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status4" }, null, -1))
const _hoisted_229 = {
  key: 2,
  class: "industry-index-box5-lt-status status5"
}
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status5" }, null, -1))
const _hoisted_231 = {
  key: 3,
  class: "industry-index-box5-lt-status status6"
}
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-lt-arrow status6" }, null, -1))
const _hoisted_233 = /*#__PURE__*/_createTextVNode(" 查看详情")
const _hoisted_234 = { class: "industry-index-box1-lt-item" }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议主题", -1))
const _hoisted_236 = { class: "industry-index-box1-lt-item" }
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议地点", -1))
const _hoisted_238 = { class: "industry-index-box1-lt-item" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议时间", -1))
const _hoisted_240 = { class: "industry-index-box1-lt-item" }
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "主办方", -1))
const _hoisted_242 = { class: "industry-index-box1-lt-item" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box1-lt-sub" }, "会议日程", -1))
const _hoisted_244 = { style: {"height":"300px"} }
const _hoisted_245 = ["innerHTML"]
const _hoisted_246 = { class: "industry-index-box5-rt" }
const _hoisted_247 = { class: "industry-index-box5-rt-hd" }
const _hoisted_248 = /*#__PURE__*/_createTextVNode(" 全部会议 ")
const _hoisted_249 = { class: "industry-index-box5-rt-box" }
const _hoisted_250 = ["onClick"]
const _hoisted_251 = { class: "industry-index-box5-rt-ad" }
const _hoisted_252 = {
  key: 0,
  class: "industry-index-box5-rt-status status3"
}
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status3" }, null, -1))
const _hoisted_254 = {
  key: 1,
  class: "industry-index-box5-rt-status status4"
}
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status4" }, null, -1))
const _hoisted_256 = {
  key: 2,
  class: "industry-index-box5-rt-status status5"
}
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status5" }, null, -1))
const _hoisted_258 = {
  key: 3,
  class: "industry-index-box5-rt-status status6"
}
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "industry-index-box5-rt-arrow status6" }, null, -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-index-box5-rt-bt" }, null, -1))
const _hoisted_261 = { class: "industry-index-box5-rt-label" }

import router from "@/router/index";
import Bottom from "../components/bottom.vue";
import store from "@/store/index";
import { reactive, ref } from "vue";

interface ActivityVoGuestVo {
  id: string;
  activityId: string;
  imgUrl: string;
  name: string;
  nickName: string;
  job: string;
  sort: number;
  allImgUrl: string;
}

interface ActivityVo {
  id: string;
  name: string;
  status: number;
  type: number;
  statusName: string;
  roomNumberName: string;
  deliveryDateString: string;
  decorateTypeName: string;
  thumbnailUrl: string;
  projectName: string;
  companyName: string;
  province: string;
  city: string;
  area: string;
  address: string;
  contact: string;
  mobile: string;
  lessonName: string;
  startTimeString: string;
  endTimeDateString: string;
  remainApplyNumber: number;
  request: string;
  activityGuestVos: ActivityVoGuestVo[],
  isChoose: boolean
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tabActivitys: ActivityVo[] = [];

const defaultActivity: ActivityVo = {
  id: '',
  name: '',
  status: 1,
  type: 1,
  statusName: '',
  roomNumberName: '',
  deliveryDateString: '',
  decorateTypeName: '',
  thumbnailUrl: '',
  projectName: '',
  companyName: '',
  province: '',
  city: '',
  area: '',
  address: '',
  contact: '',
  mobile: '',
  lessonName: '',
  startTimeString: '',
  endTimeDateString: '',
  remainApplyNumber: 0,
  request: '',
  activityGuestVos: [],
  isChoose: false
};

const bindData = reactive({
  tabIndex: 0,
  activityTagId: '563e20aa52ee4cc5ad1dbbf9834dd82e',
  activityId: '',
  images: [],
  activity: defaultActivity,
  tabActivitys: tabActivitys,
});

const boxList1 = [
  require("@/assets/fd/industry/banner3.png"),
  require("@/assets/fd/industry/banner2.png"),
  require("@/assets/fd/industry/banner1.png"),
];

const activeName = ref("社区美居俱乐部年会");
const tabs = ref([
  {
    sort: 1,
    id: '563e20aa52ee4cc5ad1dbbf9834dd82e',
    name: '社区美居俱乐部年会'
  },
  {
    sort: 2,
    id: '2cb6963de0a14ccf92e348eb38a3c06b',
    name: '家居行业论坛'
  },
  {
    sort: 3,
    id: 'd68f9f6b58064950b05a54265181d035',
    name: '专题私董会'
  },
  {
    sort: 4,
    id: 'd3a895f9db1845ab889cfd4c19a1dbc9',
    name: '企业参访'
  },
  {
    sort: 5,
    id: 'aa43a089d1024011afea6b4237547c91',
    name: '名企游学'
  },
  {
    sort: 6,
    id: 'd9db983b61364fac9be50b2c0d970313',
    name: '友商活动'
  }
])

let id = router.currentRoute.value.query.id;
if (id) {
  if (typeof(id) === "string") {
        bindData.activityTagId = id;
  }
  const tab = tabs.value.find(tab => tab.id == id);
  if (tab) {
    activeName.value = tab.name;
  }
}

const loadActivitys = function () {
  switch (bindData.tabIndex) {
    case 0:
      loadTabActivitys(3);
      break;
    case 1:
      loadTabActivitys(3);
      break;
    case 2:
      loadTabActivitys(4);
      break;
    case 3:
      break;
    case 4:
      loadTabActivitys(3);
      break;
    case 5:
      loadTabActivitys(3);
      break;
    default:
      break;
  }
  return true;
}

const getLastActivityOfTagName = () =>{
     store.dispatch("frontIndustryModule/getLastActivityOfTagName", {
     type: 5,
  })
    .then(
      (data) => {
        if(data.result){
            activeName.value = data.result;
        }
      },
      (error) => {
         console.log(error.msg);
      }
    );
}



const tabHandleClick = (tab: any, event: Event) => {
  bindData.tabIndex = Number(tab.index);
  bindData.activityTagId = tabs.value[bindData.tabIndex].id;
  bindData.activityId = '';
  bindData.activity = defaultActivity;
  bindData.tabActivitys = [];
  loadCurrActivity(4, 1, loadActivitys);
  //不是第0、1个tab异步调用
  if (bindData.tabIndex != 0 && bindData.tabIndex != 1) {
    loadActivitys();
  }
};

const loadTabActivitys = (limit: number) => {
  store.dispatch("frontIndustryModule/listActivity", {
    type: 5,
    activityTagId: bindData.activityTagId,
    limit: limit,
  })
    .then(
      (data) => {
        var activitys = data.result;
        for (let index in activitys) {
          const act = activitys[index];
          act.isChoose = false;
        }
        var resultList = [];
        if (bindData.tabIndex == 0 || bindData.tabIndex == 1) {
          //第0、1个tab同步需要排除默认的activity
          var i = 0;
          for (let index in activitys) {
            const act = activitys[index];
            if (bindData.activityId != act.id && i < limit - 1) {
              resultList[i] = act;
              i++;
            }
          }
          bindData.tabActivitys = resultList;
        }
        else {
          bindData.tabActivitys = activitys;
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
}

//当前活动：正在报名
const loadCurrActivity = (status: any, number: number, callback: () => boolean) => {
  store.dispatch("frontIndustryModule/listActivity", {
    type: 5,
    status: status,
    activityTagId: bindData.activityTagId,
    limit: 1,
  })
    .then(
      (data) => {
        if (data.result != null && data.result.length > 0) {
          bindData.activity = data.result[0];
          bindData.activity.isChoose = true;
          bindData.activityId = data.result[0].id;
          if (bindData.tabIndex == 0 || bindData.tabIndex == 1) {
            //第0、1个tab同步需要调用
            callback();
          }
        }
        else {
          switch (number) {
            case 1:
              //会议, 即将开始
              loadCurrActivity(3, number + 1, callback);
              break;
            case 2:
              //会议, 已开始
              loadCurrActivity(5, number + 1, callback);
              break;
            case 3:
              //会议, 已结束
              loadCurrActivity(6, number + 1, callback);
              break;
            default:
              break;
          }
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
}
getLastActivityOfTagName();
//会议, 正在报名
loadCurrActivity(4, 1, loadActivitys);

const handleToPage = (id: string) => {
  router.push("/frontDesk/industryIndex/industryDetail/" + id);
};

const handleToList = (id: string) => {
  router.push("/frontDesk/industryIndex/industryList/" + id);
};

const showActivity = (activity: ActivityVo) => {
  for (let index in bindData.tabActivitys) {
    const act = bindData.tabActivitys[index];
    act.isChoose = false;
    if ((bindData.tabIndex == 0 || bindData.tabIndex == 1) && act.id == activity.id) {
      bindData.tabActivitys.splice(Number(index), 1, bindData.activity);
    }
  }
  bindData.activity = activity;
  bindData.activityId = activity.id;
  bindData.activity.isChoose = true;
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((activeName).value = $event)),
            class: "demo-tabs",
            onTabClick: tabHandleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: tabs.value[0].name,
                name: tabs.value[0].name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_image, {
                      class: "industry-index-box5-bg",
                      src: require('@/assets/fd/industry/pig3.jpg')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (_unref(bindData).activityId != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(tabs.value[0].name), 1),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_el_image, {
                                  src: _unref(bindData).activity.thumbnailUrl
                                }, null, 8, ["src"]),
                                (_unref(bindData).activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                      _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                      _hoisted_11
                                    ]))
                                  : (_unref(bindData).activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                        _hoisted_13
                                      ]))
                                    : (_unref(bindData).activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_15
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_17
                                        ]))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "industry-index-box4-rt-btn",
                                type: "primary",
                                size: "default",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToPage(_unref(bindData).activity.id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.organizers), 1)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(bindData).activity.request
                                  }, null, 8, _hoisted_30)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", {
                              class: "industry-index-box5-rt-hd-text",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToList(tabs.value[4].id)))
                            }, [
                              _hoisted_33,
                              _createVNode(_component_el_icon, {
                                class: "el-icon--right",
                                style: {"color":"#ffffff"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_right)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "industry-index-box5-rt-line",
                                key: activity.id
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showActivity(activity))
                                }, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_el_image, {
                                      src: activity.thumbnailUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  (activity.status == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                        _hoisted_38
                                      ]))
                                    : (activity.status == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                          _hoisted_40
                                        ]))
                                      : (activity.status == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_42
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_44
                                          ])),
                                  _hoisted_45,
                                  _createElementVNode("div", _hoisted_46, _toDisplayString(activity.name), 1)
                                ], 8, _hoisted_35)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: tabs.value[1].name,
                name: tabs.value[1].name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_el_image, {
                      class: "industry-index-box5-bg",
                      src: require('@/assets/fd/industry/pig3.jpg')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        (_unref(bindData).activityId != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, _toDisplayString(tabs.value[1].name), 1),
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(_component_el_image, {
                                  src: _unref(bindData).activity.thumbnailUrl
                                }, null, 8, ["src"]),
                                (_unref(bindData).activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                      _hoisted_54
                                    ]))
                                  : (_unref(bindData).activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                        _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                        _hoisted_56
                                      ]))
                                    : (_unref(bindData).activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_58
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_60
                                        ]))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "industry-index-box4-rt-btn",
                                type: "primary",
                                size: "default",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToPage(_unref(bindData).activity.id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_61
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_62, [
                                _hoisted_63,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _hoisted_67,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _hoisted_69,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.organizers), 1)
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(bindData).activity.request
                                  }, null, 8, _hoisted_73)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", {
                              class: "industry-index-box5-rt-hd-text",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleToList(tabs.value[4].id)))
                            }, [
                              _hoisted_76,
                              _createVNode(_component_el_icon, {
                                class: "el-icon--right",
                                style: {"color":"#ffffff"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_right)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "industry-index-box5-rt-line",
                                key: activity.id
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showActivity(activity))
                                }, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createVNode(_component_el_image, {
                                      src: activity.thumbnailUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  (activity.status == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                        _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                        _hoisted_81
                                      ]))
                                    : (activity.status == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                          _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                          _hoisted_83
                                        ]))
                                      : (activity.status == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_85
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_87
                                          ])),
                                  _hoisted_88,
                                  _createElementVNode("div", _hoisted_89, _toDisplayString(activity.name), 1)
                                ], 8, _hoisted_78)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: tabs.value[2].name,
                name: tabs.value[2].name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_90, [
                    _createVNode(_component_el_image, {
                      class: "industry-index-box5-bg",
                      src: require('@/assets/fd/industry/pig3.jpg')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        (_unref(bindData).activityId != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                              _createElementVNode("div", _hoisted_94, _toDisplayString(tabs.value[2].name), 1),
                              _createElementVNode("div", _hoisted_95, [
                                _createVNode(_component_el_image, {
                                  src: _unref(bindData).activity.thumbnailUrl
                                }, null, 8, ["src"]),
                                (_unref(bindData).activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                      _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                      _hoisted_97
                                    ]))
                                  : (_unref(bindData).activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                        _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                        _hoisted_99
                                      ]))
                                    : (_unref(bindData).activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_101
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_103
                                        ]))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "industry-index-box4-rt-btn",
                                type: "primary",
                                size: "default",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (handleToPage(_unref(bindData).activity.id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_104
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_105, [
                                _hoisted_106,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_107, [
                                _hoisted_108,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_109, [
                                _hoisted_110,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                _hoisted_112,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.organizers), 1)
                              ]),
                              _createElementVNode("div", _hoisted_113, [
                                _hoisted_114,
                                _createElementVNode("div", _hoisted_115, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(bindData).activity.request
                                  }, null, 8, _hoisted_116)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("div", {
                              class: "industry-index-box5-rt-hd-text",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (handleToList(tabs.value[4].id)))
                            }, [
                              _hoisted_119,
                              _createVNode(_component_el_icon, {
                                class: "el-icon--right",
                                style: {"color":"#ffffff"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_right)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_120, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "industry-index-box5-rt-line",
                                key: activity.id
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showActivity(activity))
                                }, [
                                  _createElementVNode("div", _hoisted_122, [
                                    _createVNode(_component_el_image, {
                                      src: activity.thumbnailUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  (activity.status == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                        _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                        _hoisted_124
                                      ]))
                                    : (activity.status == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                          _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                          _hoisted_126
                                        ]))
                                      : (activity.status == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_128
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_130
                                          ])),
                                  _hoisted_131,
                                  _createElementVNode("div", _hoisted_132, _toDisplayString(activity.name), 1)
                                ], 8, _hoisted_121)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: tabs.value[3].name,
                name: tabs.value[3].name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_133, [
                    _createVNode(_component_el_image, {
                      class: "industry-index-box5-bg",
                      src: require('@/assets/fd/industry/pig3.jpg')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, [
                        (_unref(bindData).activityId != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                              _createElementVNode("div", _hoisted_137, _toDisplayString(tabs.value[3].name), 1),
                              _createElementVNode("div", _hoisted_138, [
                                _createVNode(_component_el_image, {
                                  src: _unref(bindData).activity.thumbnailUrl
                                }, null, 8, ["src"]),
                                (_unref(bindData).activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                      _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                      _hoisted_140
                                    ]))
                                  : (_unref(bindData).activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                        _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                        _hoisted_142
                                      ]))
                                    : (_unref(bindData).activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_144
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_146
                                        ]))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "industry-index-box4-rt-btn",
                                type: "primary",
                                size: "default",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleToPage(_unref(bindData).activity.id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_147
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_148, [
                                _hoisted_149,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_150, [
                                _hoisted_151,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_152, [
                                _hoisted_153,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                              ]),
                              _createElementVNode("div", _hoisted_154, [
                                _hoisted_155,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.organizers), 1)
                              ]),
                              _createElementVNode("div", _hoisted_156, [
                                _hoisted_157,
                                _createElementVNode("div", _hoisted_158, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(bindData).activity.request
                                  }, null, 8, _hoisted_159)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_160, [
                          _createElementVNode("div", _hoisted_161, [
                            _createElementVNode("div", {
                              class: "industry-index-box5-rt-hd-text",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (handleToList(tabs.value[4].id)))
                            }, [
                              _hoisted_162,
                              _createVNode(_component_el_icon, {
                                class: "el-icon--right",
                                style: {"color":"#ffffff"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_right)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_163, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "industry-index-box5-rt-line",
                                key: activity.id
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showActivity(activity))
                                }, [
                                  _createElementVNode("div", _hoisted_165, [
                                    _createVNode(_component_el_image, {
                                      src: activity.thumbnailUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  (activity.status == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                        _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                        _hoisted_167
                                      ]))
                                    : (activity.status == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                          _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                          _hoisted_169
                                        ]))
                                      : (activity.status == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_171
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_173
                                          ])),
                                  _hoisted_174,
                                  _createElementVNode("div", _hoisted_175, _toDisplayString(activity.name), 1)
                                ], 8, _hoisted_164)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: tabs.value[4].name,
                name: tabs.value[4].name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_176, [
                    _createVNode(_component_el_image, {
                      class: "industry-index-box5-bg",
                      src: require('@/assets/fd/industry/pig3.jpg')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("div", _hoisted_178, [
                        (_unref(bindData).activityId != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                              _createElementVNode("div", _hoisted_180, _toDisplayString(tabs.value[4].name), 1),
                              _createElementVNode("div", _hoisted_181, [
                                _createVNode(_component_el_image, {
                                  src: _unref(bindData).activity.thumbnailUrl
                                }, null, 8, ["src"]),
                                (_unref(bindData).activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                      _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                      _hoisted_183
                                    ]))
                                  : (_unref(bindData).activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                        _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                        _hoisted_185
                                      ]))
                                    : (_unref(bindData).activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_187
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_189
                                        ]))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "industry-index-box4-rt-btn",
                                type: "primary",
                                size: "default",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (handleToPage(_unref(bindData).activity.id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_190
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_191, [
                                _hoisted_192,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_193, [
                                _hoisted_194,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_195, [
                                _hoisted_196,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                              ]),
                              _createElementVNode("div", _hoisted_197, [
                                _hoisted_198,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.organizers), 1)
                              ]),
                              _createElementVNode("div", _hoisted_199, [
                                _hoisted_200,
                                _createElementVNode("div", _hoisted_201, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(bindData).activity.request
                                  }, null, 8, _hoisted_202)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_203, [
                          _createElementVNode("div", _hoisted_204, [
                            _createElementVNode("div", {
                              class: "industry-index-box5-rt-hd-text",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (handleToList(tabs.value[4].id)))
                            }, [
                              _hoisted_205,
                              _createVNode(_component_el_icon, {
                                class: "el-icon--right",
                                style: {"color":"#ffffff"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_right)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_206, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "industry-index-box5-rt-line",
                                key: activity.id
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showActivity(activity))
                                }, [
                                  _createElementVNode("div", _hoisted_208, [
                                    _createVNode(_component_el_image, {
                                      src: activity.thumbnailUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  (activity.status == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                                        _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                        _hoisted_210
                                      ]))
                                    : (activity.status == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                          _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                          _hoisted_212
                                        ]))
                                      : (activity.status == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_214
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_215, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_216
                                          ])),
                                  _hoisted_217,
                                  _createElementVNode("div", _hoisted_218, _toDisplayString(activity.name), 1)
                                ], 8, _hoisted_207)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: tabs.value[5].name,
                name: tabs.value[5].name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_219, [
                    _createVNode(_component_el_image, {
                      class: "industry-index-box5-bg",
                      src: require('@/assets/fd/industry/pig3.jpg')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_220, [
                      _createElementVNode("div", _hoisted_221, [
                        (_unref(bindData).activityId != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                              _createElementVNode("div", _hoisted_223, _toDisplayString(tabs.value[5].name), 1),
                              _createElementVNode("div", _hoisted_224, [
                                _createVNode(_component_el_image, {
                                  src: _unref(bindData).activity.thumbnailUrl
                                }, null, 8, ["src"]),
                                (_unref(bindData).activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_225, [
                                      _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                      _hoisted_226
                                    ]))
                                  : (_unref(bindData).activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                        _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                        _hoisted_228
                                      ]))
                                    : (_unref(bindData).activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_230
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_231, [
                                          _createTextVNode(_toDisplayString(_unref(bindData).activity.statusName) + " ", 1),
                                          _hoisted_232
                                        ]))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "industry-index-box4-rt-btn",
                                type: "primary",
                                size: "default",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (handleToPage(_unref(bindData).activity.id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_233
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_234, [
                                _hoisted_235,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_236, [
                                _hoisted_237,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_238, [
                                _hoisted_239,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                              ]),
                              _createElementVNode("div", _hoisted_240, [
                                _hoisted_241,
                                _createElementVNode("div", null, _toDisplayString(_unref(bindData).activity.organizers), 1)
                              ]),
                              _createElementVNode("div", _hoisted_242, [
                                _hoisted_243,
                                _createElementVNode("div", _hoisted_244, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(bindData).activity.request
                                  }, null, 8, _hoisted_245)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_246, [
                          _createElementVNode("div", _hoisted_247, [
                            _createElementVNode("div", {
                              class: "industry-index-box5-rt-hd-text",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (handleToList(tabs.value[4].id)))
                            }, [
                              _hoisted_248,
                              _createVNode(_component_el_icon, {
                                class: "el-icon--right",
                                style: {"color":"#ffffff"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_right)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_249, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "industry-index-box5-rt-line",
                                key: activity.id
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showActivity(activity))
                                }, [
                                  _createElementVNode("div", _hoisted_251, [
                                    _createVNode(_component_el_image, {
                                      src: activity.thumbnailUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  (activity.status == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                        _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                        _hoisted_253
                                      ]))
                                    : (activity.status == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                                          _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                          _hoisted_255
                                        ]))
                                      : (activity.status == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_257
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_258, [
                                            _createTextVNode(_toDisplayString(activity.statusName) + " ", 1),
                                            _hoisted_259
                                          ])),
                                  _hoisted_260,
                                  _createElementVNode("div", _hoisted_261, _toDisplayString(activity.name), 1)
                                ], 8, _hoisted_250)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label", "name"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})